/* Oct 16 2026: donations program (register + offer pages). No outside requests. Both forms are Shopify contact forms and post without this file.
   Offer page: add item rows (max 10), write a text summary into contact[body], write contact[recipient], preselect ?to=<handle>.
   Both forms set data-ksg-native on submit so assets/ksg-quote.js lets the browser post normally and the page returns with ?contact_posted=true. */
(function () {
  "use strict";
  var MAX = 10, KEY = "ksg-donate-rcpt";
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function today() { var d = new Date(), p = function (n) { return (n < 10 ? "0" : "") + n; }; return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate()); }
  function clean(s) { return String(s == null ? "" : s).replace(/[\r\n]+/g, " ").replace(/\s+/g, " ").trim(); }

  function nativePost(form) {
    form.addEventListener("submit", function () {
      form.setAttribute("data-ksg-native", "1");
      $$('button[type="submit"]', form).forEach(function (b) { b.disabled = true; b.textContent = "Sending..."; });
    });
  }

  /* success message on the offer page: show the recipient chosen before the page reloaded */
  var rcptText = $("[data-ksg-donate-rcpt]");
  if (rcptText) {
    try {
      var saved = sessionStorage.getItem(KEY);
      if (saved) rcptText.textContent = saved;
      else if (saved === "") rcptText.textContent = "an organization that needs it";
      sessionStorage.removeItem(KEY);
    } catch (e) {}
  }

  var reg = $("#ksg-donate-reg");
  if (reg) nativePost(reg);

  var form = $("#ksg-donate-offer");
  if (!form) return;
  var rowsBox = $("[data-ksg-rows]", form), tpl = $("[data-ksg-row-tpl]", form), addBtn = $("[data-ksg-add]", form), hint = $("[data-ksg-addhint]", form);
  var sel = $("[data-ksg-rcpt]", form), hid = $("[data-ksg-rcpt-hidden]", form), body = $("[data-ksg-body]", form), credit = $("[data-ksg-credit]", form);
  if (!rowsBox || !tpl || !sel) return;
  var counter = 1;

  $$("[data-ksg-exp]", form).forEach(function (el) { el.min = today(); });

  function rows() { return $$("[data-ksg-row]", rowsBox); }
  function renumber() {
    var list = rows();
    list.forEach(function (r, i) {
      var n = $("[data-ksg-ln]", r); if (n) n.textContent = String(i + 1);
      var rm = $("[data-ksg-remove]", r); if (rm) rm.hidden = list.length < 2;
    });
    if (addBtn) { addBtn.hidden = false; addBtn.disabled = list.length >= MAX; }
    if (hint) hint.hidden = list.length < MAX;
  }
  function labelIds(r, n) {
    $$("label", r).forEach(function (l) {
      var f = $("input, select, textarea", l); if (!f) return;
      f.id = "ksg-donate-" + n + "-" + (f.getAttribute("data-f") || "x");
    });
  }
  labelIds(rows()[0], 1);

  function addRow() {
    if (rows().length >= MAX) return;
    counter += 1;
    var wrap = document.createElement("div");
    wrap.innerHTML = tpl.innerHTML.split("__N__").join(String(counter));
    var r = wrap.firstElementChild || wrap.firstChild;
    if (!r) return;
    rowsBox.appendChild(r);
    labelIds(r, counter);
    $$("[data-ksg-exp]", r).forEach(function (el) { el.min = today(); });
    renumber();
    var first = $("input", r); if (first) first.focus();
  }
  if (addBtn) addBtn.addEventListener("click", addRow);
  rowsBox.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute("data-ksg-remove")) return;
    var r = t.closest("[data-ksg-row]");
    if (r && rows().length > 1) { r.parentNode.removeChild(r); renumber(); var a = $("input", rows()[0]); if (a) a.focus(); }
  });
  renumber();

  /* ?to=<handle> preselects the recipient */
  try {
    var to = new URLSearchParams(window.location.search).get("to");
    if (to) {
      var opt = $$("option", sel).filter(function (o) { return o.value === to; })[0];
      if (opt) sel.value = to;
    }
  } catch (e) {}

  function rcptLabel() {
    var o = sel.options[sel.selectedIndex];
    if (!o || o.value === "keystone-places") return { handle: "keystone-places", name: "" };
    return { handle: o.value, name: o.getAttribute("data-name") || clean(o.textContent) };
  }
  function summary() {
    var rc = rcptLabel(), out = [];
    out.push("Donation offer");
    out.push("Recipient: " + (rc.name ? rc.handle + " | " + rc.name : "Keystone to place it"));
    var list = rows();
    out.push("Items (" + list.length + "):");
    list.forEach(function (r, i) {
      var v = function (k) { var el = $('[data-f="' + k + '"]', r); return el ? clean(el.value) : ""; };
      var parts = [v("item")];
      if (v("mfr")) parts.push("Mfr " + v("mfr"));
      if (v("number")) parts.push("Item # " + v("number"));
      parts.push("Qty " + v("amount") + " " + v("unit"));
      if (v("lot")) parts.push("Lot " + v("lot"));
      parts.push("Exp " + v("exp"));
      parts.push(v("cond"));
      parts.push(v("store"));
      out.push((i + 1) + ". " + parts.join(" | "));
    });
    var g = function (n) { var el = $('[name="contact[' + n + ']"]', form); return el ? clean(el.value) : ""; };
    out.push("Pickup: " + g("pickup_city") + ", " + g("pickup_state") + (g("available_until") ? " | Available until " + g("available_until") : "") + " | Can ship: " + g("can_ship"));
    out.push("Public credit: " + (credit && credit.checked ? "yes" : "no"));
    return out.join("\n");
  }

  form.addEventListener("submit", function () {
    var rc = rcptLabel();
    hid.value = rc.name ? rc.handle + " | " + rc.name : rc.handle;
    body.value = summary();
    try { sessionStorage.setItem(KEY, rc.name); } catch (e) {}
    /* the summary carries the lines; drop the per-row names so the email does not list every item twice */
    $$("[data-ksg-row] [name]", form).forEach(function (el) { el.removeAttribute("name"); });
    form.setAttribute("data-ksg-native", "1");
    $$('button[type="submit"]', form).forEach(function (b) { b.disabled = true; b.textContent = "Sending..."; });
  });
})();
